import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import PowerBIIcon from "../../../assests/power-bi-icon.svg";

export default function ReportDetails({ subdomain, searchQuery, onReportClick }) {
  const reports = subdomain?.Reports || [];
  const filtered = reports.filter((report) =>
    report.report_name.toLowerCase().includes(searchQuery?.toLowerCase() || "")
  );

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="overflow-x-auto" style={{ overflowY: "auto", maxHeight: "600px" }}>
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50" style={{ position: "sticky", top: 0, zIndex: 10 }}>
            <tr>
              <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase w-[25%]">Report Name</th>
              <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase w-[40%]">Description</th>
              <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase w-[20%]">Link</th>
              <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase w-[15%]">Owner</th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {filtered.map((report, index) => (
              <tr
                key={report.report_id}
                className={`cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-50"} hover:bg-blue-50 transition-colors`}
                onClick={() => onReportClick && onReportClick(report)} 
              >
                <td className="px-6 py-4 w-[25%]">
                  <div className="flex items-center gap-3">
                    <span className="bg-[#f0c030] w-[35px] h-[35px] rounded-xl flex items-center justify-center flex-shrink-0">
                      <img src={PowerBIIcon} alt="Power BI" style={{ width: "20px", height: "20px" }} />
                    </span>
                    <span className="text-sm font-medium cursor-pointer ">
                      {report.report_name}
                    </span>
                  </div>
                </td>

                <td className="px-6 py-4 w-[40%]">
                  <span className="text-sm text-gray-600">
                    {report.description || "N/A"}
                  </span>
                </td>

                <td className="px-6 py-4 whitespace-nowrap w-[20%]">
                  {report.report_link ? (
               <a
                      href={report.report_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                      onClick={(e) => e.stopPropagation()}
                    >
                      View Report <FaExternalLinkAlt size={12} />
                    </a>
                  ) : (
                    <span className="text-sm text-gray-600">N/A</span>
                  )}
                </td>

                <td className="px-6 py-4 whitespace-nowrap w-[15%]">
                  <span className="text-sm text-gray-600">
                    {report.report_owner || "N/A"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}